import React from 'react';
import { navigateTo } from "gatsby-link"
import { Transition, Container, Rail, Dimmer, Header, Label,
  Feed, Card, Icon, Image, Message,
  List, Tab, Divider, Segment,
  Menu, Dropdown, Item, Accordion } from 'semantic-ui-react'
import he from 'he';
import ReactDOM from 'react-dom';
import Comments from '../components/Comments'
import SocialMediaTag from '../components/SocialMediaTag'
import StructureData from '../components/StructureData'
import { Article } from '../components/StructureData'
import Helmet from 'react-helmet'
import { slash, uniThumbnailPath, toSlug, arrayToURL } from '../utils/utils'
import styles from './university.module.css'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'




const MainSection = ({uname, subheadline, about}) => {
  return <Item>
    <Header textAlign='center' as='h1' size='medium'> {uname.toUpperCase()}
    <Divider fitted /></Header>
    <Divider hidden />
    <Image src='/covers/university/university-banner.jpg' size='huge'/>
    <Item.Meta><span>{subheadline}</span></Item.Meta>
    <Divider hidden />
    <Header as='h3' size='medium'>ABOUT</Header>
    <Item.Description>{about}</Item.Description>
  </Item>
}

const Gallery = ({images, title}) => {
  return <Carousel showArrows={true} showThumbs={false}>
     {images.map((img) => {
       return <div>
         <img src={img} />
       </div>
     })}
  </Carousel>
}

const MajorLabel = ({major, uslug}) => {

  const navTo = ({url}) => {
    navigateTo(url)
  }

  const url = arrayToURL([toSlug(uslug), toSlug(major)]);
  return <Label as='a' onClick={() => navTo({url})} href={slash(url)}>{major}</Label>
}

const MajorAt = ({majors, courses, uslug, ctx}) => {
  const handleClick = ctx.handleClick;
  const activeIndex = ctx.state.activeIndex;
  const navTo = ({url}) => {
    navigateTo(url)
  }
  return <Accordion styled fluid>
    {majors.map((major, idx) => {
      return <div>
      <Accordion.Title active={activeIndex === idx} index={idx} onClick={handleClick}>
        {major}
      </Accordion.Title>
      <Accordion.Content active={activeIndex === idx}>
        <List>
        {courses.map(({node}) => {
          const mname = node.major;
          const title = node.title;
          const url = slash(arrayToURL([uslug,toSlug(title)]));
          if(mname === major) {
            return <List.Item>
                <List.Content>
                  <List.Header as='a' onClick={() => navTo({url})} >{title}</List.Header>
                </List.Content>
                <a style={{display:'none'}} href={url}>{mname} - {title}</a>
              </List.Item>
          }
        })}
        </List>
      </Accordion.Content>
      </div>
    })}
  </Accordion>
}

const Facility = ({services, uname}) => {
  if(services.length === 0) {
    return <div>
      Information Not Available
    </div>
  }
  return <Message>
    <List relaxed>
    {services.map((x, key) => {
      return <List.Item key={key}>
        <List.Icon name='checkmark box' />
        <List.Content>
          <List.Header>{x}</List.Header>
        </List.Content>
        <Divider hidden fitted />
      </List.Item>
    })}
    </List>
    </Message>
}

const Contacts = ({address}) => {
  return <div>

    <Message>
     <Message.Header><Icon name='marker' size='large'/>Address</Message.Header>
      {address}
    </Message>
  </div>
}


class UniversityDetails extends React.Component {

  state = { activeIndex: -1 }

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      tooltip: false
    }
  }

  componentDidMount() {

    const _this = this;

    ReactDOM.findDOMNode(this.props.top).scrollIntoView();

    if(typeof FB !== "undefined") {
      FB.XFBML.parse();
    }
  }

  render() {
    this.handleClick = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
      this.setState({ activeIndex: newIndex })
    }


    const path = this.props.location.pathname;
    const { tooltip, active } = this.state;
    const { university, uname } = this.props.pathContext;
    const { address, uslug, about, services, gallery } = university;
    const majors = this.props.data.majors.distinct;
    const courses = this.props.data.majors.courses;

    const description = `Interested study in ${uname}? You will find it's general information here.
     Also we help you connect to your desired university. Take your action now, contact us!`
    const pageTitle = `${uname} General Information | Uni Village Education`;
    const article = Article("Uni Village Education", uname,
      "UniVillage", "https://www.univillage.co",
      description, [`${process.env.URL}/covers/university/university-banner.jpg`]);

    const panes = [];
    if(gallery.campus) {
      panes.push({ menuItem: 'Campus', render: () => <Tab.Pane attached={false}><Gallery images={gallery.campus} /></Tab.Pane> })
    }

    if(gallery.facilities) {
       panes.push({ menuItem: 'Facility', render: () => <Tab.Pane attached={false}><Gallery images={gallery.facilities} /></Tab.Pane> })
    }

    if(gallery.lifestyle) {
      panes.push({ menuItem: 'Lifestyle', render: () => <Tab.Pane attached={false}><Gallery images={gallery.lifestyle} /></Tab.Pane> })
    }

    return  <Dimmer.Dimmable blurring dimmed={active}>
      <Dimmer active={active} inverted />
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={description} />
        </Helmet>
        <SocialMediaTag type="article"
          image={`${process.env.URL}/covers/university/university-banner.jpg`}
          title={pageTitle}
          url={path}
          description={description}
        />
        <StructureData meta={article} />
      { tooltip &&
      <Transition animation='scale' duration={1000} visible={tooltip}>
        <Header as='h4' icon textAlign='center' disabled>
          <Icon name='magnet' loading />
          You Are Viewing {uname} Information
        </Header>
      </Transition>
      }
        <div className={styles.content}>
        <MainSection uname={uname} subheadline="" about={about} />
        <Header as='h2' size='medium'>MAJORS IN {uname.toUpperCase()}<Divider fitted /></Header>
        <MajorAt majors={majors} courses={courses} uslug={uslug} ctx={this}/>
        <Header as='h3' size='medium'>Facilities<Divider fitted /></Header>
        <Facility services={services} uname={uname}/>
        <Header as='h3' size='medium'>Contacts<Divider fitted /></Header>
        <Contacts address={address} />
        <Divider hidden />
        <Header as='h3' size='medium'>Gallery<Divider fitted /></Header>
        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        <Divider hidden />
      </div>
      <Comments path={path} />
    </Dimmer.Dimmable>
  }
}
export const pageQuery = graphql`
  query CourseAt($uname:String!){
    majors: allCourseMajorJson(filter:{university: { eq: $uname} }) {
      distinct(field: major)
      courses: edges {
        node {
          major
          title
        }
      }
    }
}`

export default UniversityDetails;



// WEBPACK FOOTER //
// ./src/templates/university-details.js